import { mode } from '@chakra-ui/theme-tools';

export const linkStyles = {
  components: {
    Link: {
      decoration: 'none',
      baseStyle: {
        color: '#099BFF',
        transition: '0.3s all',
        fontSize: '16px',
        fontWeight: '600',
        _hover: {
          textDecoration: 'underline'
        },
        _focus: {
          boxShadow: 'none',
        },
      },
      variants: {
        'standart': (props) => ({
          color: mode('blue.800', 'gray.50')(props),
          fontWeight: '400',
        }),
        'decoration': (props) => ({
          color: mode('blue.800', '#099BFF')(props),
          fontWeight: '500',
          textDecoration: 'underline',
          _hover: {
            textDecoration: 'underline'
          },
          _focus: {
            boxShadow: 'none',
          },
        }),
        'menu': (props) => ({
          transition: '0.3s all',
          color: mode('blue.800', '#9FABCB')(props),
          fontWeight: '600',
          fontSize: '16px',
          textDecoration: 'none',
          _hover: {
            color: mode('blue.800', '#099BFF')(props),
            textDecoration: 'none',
          },
          _active: {
            color: mode('blue.800', '#099BFF')(props),
            textDecoration: 'none',
          },
        }),
      }
    }
  },
};
